import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
    successAlertDispatcher,
    errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { HEADERS } from "./cha.constants";
import { FEATURES } from "../../../utils/constant";

class CHA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: [],
            loadingData: true,
        };
    }

    componentDidMount() {
        ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/cha` })
            .then((dataArray) => {
                this.setState({
                    rowData: isEmpty(dataArray) ? [] : dataArray.data.resultSet,
                    loadingData: false,
                });
            })
            .catch((err) => {
                console.log(err);
                this.setState({ loadingData: false, rowData: [] });
            });
    }

    onCellClicked = (rowData) => {
        typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }

    onRowEdit = (rowData) => {
        this.props.history.push("/edit-cha", {
            ...rowData,
            title: "edit_title",
        });
    };

    onRowDelete = (alert) => {
        if (alert.type === "success") this.props.successAlert(alert);
        else this.props.errorAlert(alert);
        this.props.history.push("/cha");
        this.props.history.go();
    };

    render() {
        const { rowData } = this.state;
        const { t } = this.props;
        const Columns = [
            {
                headerName: HEADERS.chaCode || "CHA Code",
                field: "CHACode",
                sortable: true,
                filter: true,
            },
            {
                headerName: HEADERS.chaName || "CHA Name",
                field: "CHAName",
                sortable: true,
                filter: true,
            },
            {
                headerName: HEADERS.createdByName || "Created By",
                field: "createdByName",
                sortable: true,
                filter: true,
            },
            {
                headerName: HEADERS.createdOn || "Created On",
                field: "createdOn",
                sortable: true,
                filter: true,
            },
            {
                headerName: HEADERS.updatedByName || "Modified By",
                field: "updatedByName",
                sortable: true,
                filter: true,
            },
            {
                headerName: HEADERS.updatedOn || "Modified On",
                field: "updatedOn",
                sortable: true,
                filter: true,
            },
            {
                headerName: HEADERS.edit || "Edit / Delete",
                field: "edit",
                cellRenderer: "actionRenderer",
                suppressToolPanel: true,
                pinned: "right",
            },
        ];
        return (
            <React.Fragment>
                <AgGridTable
                    isLoading={this.state.loadingData}
                    columnDefs={Columns}
                    rowData={rowData}
                    titleBarTitle={"CHA"}
                    titleBarLink={"/add-cha"}
                    baseURL={"cha"}
                    pathName={"chaMaster"}
                    keyIndex={"CHAId"}
                    onEdit={this.onRowEdit}
                    cellDoubleClicked={this.onCellClicked}
                    onDelete={this.onRowDelete}
                    hideFilter={true}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        );
    }
}
const mapStateToProps = ({ permissions }) => {
    return {
        permissions,
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
        errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("cha")(CHA));
